export const dummyCharacterResponseData = {
  _id: "63dfff1c88b3836b646e8008",
  characterId: 10000002,
  type: "Ayaka - Boss Slayer [2p 2p]",
  uid: "701464050",
  artifactObjects: {
    EQUIP_SHOES: {
      mainStatKey: "ATK%",
    },
    EQUIP_RING: {
      mainStatKey: "Cryo DMG Bonus",
    },
    EQUIP_DRESS: {
      mainStatKey: "Crit RATE",
    },
  },
  artifactSets: {
    "Noblesse Oblige": {
      icon: "https://enka.network/ui/UI_RelicIcon_15007_4.png",
      count: 2,
    },
    "Shimenawa's Reminiscence": {
      icon: "https://enka.network/ui/UI_RelicIcon_15019_4.png",
      count: 2,
    },
    "Gladiator's Finale": {
      icon: "https://enka.network/ui/UI_RelicIcon_15001_4.png",
      count: 1,
    },
  },
  constellation: 4,
  costumeId: "",
  critValue: 233.23999701666736,
  fetterInfo: {
    expLevel: 10,
  },
  md5: "d767e44f4157ecf62872b0b368afa259",
  name: "Kamisato Ayaka",
  owner: {
    nickname: "Mimee",
    adventureRank: 60.0000005924,
    profilePicture: {
      characterId: 0,
      id: 7400,
      assets: {
        icon: "UI_AvatarIcon_Furina_Circle",
        oldIcon: "UI_AvatarIcon_Furina",
      },
      name: null,
    },
    nameCard: "UI_NameCardPic_LuminanceStone_P",
    patreon: {
      color: "cyan",
      active: true,
    },
    region: "EU",
  },
  propMap: {
    ascension: {
      val: "6",
    },
    level: {
      val: "90",
    },
  },
  proudSkillExtraLevelMap: {
    "239": 3,
  },
  skillDepotId: 201,
  stats: {
    critRate: {
      value: 0.8510007314672546,
    },
    critDamage: {
      value: 2.055424695490845,
    },
    energyRecharge: {
      value: 1.3303008131971437,
    },
    healingBonus: {
      value: 0,
    },
    incomingHealingBonus: {
      value: 0,
    },
    elementalMastery: {
      value: 0,
    },
    physicalDamageBonus: {
      value: 0,
    },
    geoDamageBonus: {
      value: 0.12000072049999999,
    },
    cryoDamageBonus: {
      value: 0.5860007112016754,
    },
    pyroDamageBonus: {
      value: 0.12000072049999999,
    },
    anemoDamageBonus: {
      value: 0.12000072049999999,
    },
    hydroDamageBonus: {
      value: 0.12000072049999999,
    },
    dendroDamageBonus: {
      value: 0.12000072049999999,
    },
    electroDamageBonus: {
      value: 0.12000072049999999,
    },
    maxHp: {
      value: 18762.0136725955,
    },
    atk: {
      value: 2404.2031257205,
    },
    def: {
      value: 800.12548900175,
    },
  },
  talentsLevelMap: {
    normalAttacks: {
      icon: "https://enka.network/ui/Skill_A_01.png",
      level: 10,
      rawLevel: 10,
      id: 10024,
      boosted: false,
    },
    elementalSkill: {
      icon: "https://enka.network/ui/Skill_S_Ayaka_01.png",
      level: 10,
      rawLevel: 10,
      id: 10018,
      boosted: false,
    },
    elementalBurst: {
      icon: "https://enka.network/ui/Skill_E_Ayaka.png",
      level: 13,
      rawLevel: 10,
      id: 10019,
      boosted: true,
    },
  },
  weapon: {
    weaponInfo: {
      level: 90,
      promoteLevel: 6,
      refinementLevel: {
        value: 0,
      },
    },
    flat: {
      icon: {
        value: "UI_EquipIcon_Sword_Narukami",
      },
    },
    name: "Mistsplitter Reforged",
    icon: "https://enka.network/ui/UI_EquipIcon_Sword_Narukami_Awaken.png",
  },
  customNamecard: "63c514dfb9306912cdc0917a696cf522.jpg",
  icon: "https://enka.network/ui/UI_AvatarIcon_Ayaka.png",
  index: 2,
  nameCardLink: "https://enka.network/ui/UI_NameCardPic_LuminanceStone_P.png",
  profilePictureLink: "https://enka.network/ui/UI_AvatarIcon_Furina.png",
  characterMetadata: {
    element: "Cryo",
  },
};

export const dummyArtifactResponseData = {
  uid: "701464050",
  owner: {
    nickname: "Mimee",
    adventureRank: 60,
    profilePicture: {
      characterId: 0,
      id: 7400,
      assets: {
        icon: "UI_AvatarIcon_Furina_Circle",
        oldIcon: "UI_AvatarIcon_Furina",
      },
      name: null,
    },
    nameCard: "UI_NameCardPic_LuminanceStone_P",
    patreon: {
      color: "cyan",
      active: true,
      id: "153942038138585088",
    },
    discord: {
      color: "cyan",
      active: true,
      id: "153942038138585088",
    },
    region: "EU",
  },
  name: "Shaft of Remembrance",
  setName: "Shimenawa's Reminiscence",
  stars: 5,
  mainStatKey: "Flat ATK",
  mainStatValue: 311.000000087,
  equipType: "EQUIP_NECKLACE",
  level: 21,
  critValue: 33.419999567247494,
  icon: "https://enka.network/ui/UI_RelicIcon_15019_2.png",
  substats: {
    "ATK%": 5.249999923087227,
    "Crit DMG": 20.19999967274772,
    "Energy Recharge": 16.190000337935555,
    "Crit RATE": 6.6100000342498895,
  },
  substatsIdList: [
    501063, 501224, 501234, 501201, 501232, 501223, 501204, 501231, 501221,
  ],
  _id: "8d7e948e1b412d784a88099132dd1611",
};
